import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// IMAGES
import RedLink from '../../../assets/clients/RedLink.png'
import WiseUp from '../../../assets/clients/WiseUp.png'
import Ecuador from '../../../assets/clients/Ecuador.png'
import Falabella from '../../../assets/clients/Falabella.png'
import Quilmes from '../../../assets/clients/Quilmes.png'
import MixTail from '../../../assets/clients/MixTail.png'

import './Clients.css'

export default class Clients extends React.Component{
 render(){
  return(
    <section className="MainContainer">
     <div style={{textAlign: 'center'}}>
        <Typography 
          variant="title" 
          style={{marginBottom: 30, marginTop: 40, fontWeight: 500}}>
            Some of our Clients
        </Typography>
        <Grid container justify="center">
          <Grid item className="BrandContainer" >
          <div className="BrandButton">
 {/*<Button className={css(styles.introButton)}>
        SEE MORE  
    </Button>*/}
          </div>
            <div className="BrandImages">
              <img className={css(styles.image)} src={RedLink} alt=""/>
              <img className={css(styles.image)} src={Falabella} alt=""/>
              <img className={css(styles.image)} src={Quilmes} alt=""/>
              <img className={css(styles.image)} src={MixTail} alt=""/>
              <img className={css(styles.image)} src={WiseUp} alt=""/>
              <img className={css(styles.image)} src={Ecuador} alt=""/>
            </div>
          </Grid>
        </Grid>
     </div>
    </section>
  );
 }
}

const styles = StyleSheet.create({
  image: {
    maxHeight: 70,
    margin: '0 25px',
    transition: 'all .2s ease-in-out',
  },
     introButton: {
        color: 'white',
        background:'linear-gradient(-69deg, #FF6B4D, #D85944)',
        border: '.5px solid white',
        lineHeight: 0,
        marginTop: '5%',
        opacity: '1',
        // transition: 'all ease-in-out .2s',
        ':hover':{
            // transform: 'translate(0, -2px)',
            // boxShadow: '0 2px 10px rgba(50,50,93,.2), 0 8px 15px rgba(0,0,0,.07)',
        }
    },
})


// WEBPACK FOOTER //
// ./src/Components/Home/Clients/Clients.js